import React from 'react';
import { connect } from 'react-redux';
import {
  datasetAdminUrl, datasetUrl, newDatasetUrl, newRequestUrl,
} from '@/constants/urls';
import { newCohortFromDataset } from '@/cohorts/actions';
import { requestSources } from '@/requests/constants';
import DropdownItem from '@/components/DropdownItem';
import { datasetAdminPermissions, datasetPermissions } from '../sharing/constants';
import datasetStatus from '../status/helper';
import canManageDataset from '../sharing/helper';
import { showDatasetConditions } from '../conditions/actions';
import { datasetSourceEntities } from '../constants';

const DatasetTools = ({
  accessRequestAllowed,
  accessRequestSupported,
  allowAudit,
  allowClone,
  allowManage,
  cohortAllowed,
  cohortSupported,
  dataset,
  hasConditions,
  newCohort,
  newCohortCode,
  newDatasetCode,
  newRequestCode,
  showConditions,
}) => (
  <>
    {allowClone && (
    <DropdownItem
      icon="clone"
      textId="actions.duplicate"
      href={newDatasetUrl(datasetSourceEntities.DATASET, dataset.code, newDatasetCode, '#')}
    />
    )}
    {allowManage && (
      <DropdownItem icon="sliders" textId="actions.manage" href={datasetAdminUrl(dataset, '#')} />
    )}
    {accessRequestAllowed && accessRequestSupported && (
      <DropdownItem
        icon="key"
        textId="actions.request.access"
        href={newRequestUrl(requestSources.DATASET, dataset.code, newRequestCode, '#')}
      />
    )}
    {cohortAllowed && cohortSupported && (
      <DropdownItem
        icon="filter"
        textId="actions.cohort"
        onClick={() => newCohort(newCohortCode, dataset.code, dataset.primary_dictionary)}
      />
    )}
    {hasConditions && accessRequestAllowed && (
    <DropdownItem
      icon="clipboard list"
      textId="actions.conditions"
      onClick={() => showConditions(requestSources.DATASET, dataset.code, dataset.catalogue.title)}
    />
    )}
    {allowAudit && (<DropdownItem icon="history" textId="actions.audit" href={`${datasetUrl(dataset, '#')}/audits`} />)}
  </>
);

const mapStateToProps = ({
  auth: { role },
  cohorts: { newCohortCode },
  datasets: { newDatasetCode },
  requests: { newRequestCode },
}, { dataset }) => {
  const { datasets } = role.permissions;
  const { permissions } = dataset;
  return ({
    allowAudit: datasets.audit && permissions[datasetAdminPermissions.AUDIT],
    allowClone: datasets.create && permissions[datasetPermissions.UPDATE],
    allowManage: datasets.update && canManageDataset(permissions),
    newCohortCode,
    newDatasetCode,
    newRequestCode,
    ...datasetStatus(role, dataset, dataset.primary_dictionary),
  });
};

const mapDispatchToProps = {
  newCohort: (code, datasetCode, dictionaryCode) => (
    newCohortFromDataset(code, 'open', datasetCode, [dictionaryCode])),
  showConditions: showDatasetConditions,
};

export default connect(mapStateToProps, mapDispatchToProps)(DatasetTools);
